import { useCallback, useState } from 'react';
import { reportError } from 'utils/reporting';
import { showNotification } from 'common/function';
import { isApiError } from 'common/types';
import { useCurrentUser } from './useCurrentUser';
import { FeatureFlag, TenancyService, TenantInfo } from 'types';
import { useFeatureFlag } from 'hooks/featureFlags/useFeatureFlag';
import { LegacyTenancyService } from 'service/TenancyService';

export function useTenantsLazy() {
  const { user } = useCurrentUser();
  const [availableTenants, setAvailableTenants] = useState<TenantInfo[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const isTenantManagementEnabled = useFeatureFlag(FeatureFlag.TENANCY_MANAGEMENT);

  const loadTenants = useCallback(async () => {
    if (!user) {
      return;
    }

    setIsLoading(true);

    try {
      const tenants = isTenantManagementEnabled
        ? await TenancyService.listTenancies()
        : await LegacyTenancyService.listTenancies(user);
      setAvailableTenants(tenants);
    } catch (err: any) {
      reportError(err);
      showNotification(isApiError(err) ? err.body.error : err.message, 'Load Tenants Error', 'error');
    }

    setIsLoading(false);
  }, [user, isTenantManagementEnabled]);

  return {
    availableTenants,
    isLoading,
    loadTenants,
  };
}
